import { Colors } from '@/api';
import { DialogChainObject, QDialogOptions } from 'quasar';
import { showProgrammaticDialog } from './programmaticDialog';

interface LocalDialogOptions extends QDialogOptions {
  okLabel?: string;
  hideCancelButton?: boolean;
  cancelLabel?: string;
  color?: Colors;
  icon?: string;
  width?: string;
  onOk?: (data?: string[]) => DialogChainObject | Promise<void>;
  onCancel?: (data?: string[]) => DialogChainObject | Promise<void>;
}

export const dialog = (options: LocalDialogOptions) => {
  // Use the new BaseModal-based programmatic dialog system
  return showProgrammaticDialog({
    title: options.title as string | undefined,
    message: options.message as string,
    okLabel: options.okLabel,
    cancelLabel: options.cancelLabel,
    hideCancelButton: options.hideCancelButton,
    color: options.color,
    icon: options.icon,
    width: options.width,
    html: options.html,
    onOk: options.onOk as (() => void | Promise<void>) | undefined,
    onCancel: options.onCancel as (() => void | Promise<void>) | undefined,
  });
};
